export default __webpack_public_path__ + "static/blog-highlight-bg-6c460be4d4c1ef327e7be34c83c5d19d.jpg";